import StaticContentsContainer from '../components/StaticContentsContainer';
import documentRobot from '../../../../assets/images/test/document-robot.png';

function DocumentDeliveryRobotDescription() {
    const container = StaticContentsContainer();
    container.classList.add('robot-description');
    container.innerHTML = `
    <h2>문서 배송 로봇</h2>
    <div class="robot-img-container">
        <div class="robot-img">
            <img src="${documentRobot}" alt="document delivery robot">
        </div>
    </div>
    <ul class="robot-description-list">
        <li class="robot-description-item">약제나 검체에 비해 문서 수거 빈도가 적어 가성비가 낮은 편입니다.</li>
        <li class="robot-description-item">부서별 행정 서류와 외부 병원 기록지 등 로봇이 순회하며 처리 가능합니다.</li>              
    </ul>
    `;
    return container;
}

export default DocumentDeliveryRobotDescription;
